var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDesktop)?_c('PossibilitiesDesktop',{attrs:{"animation-enabled":_vm.animationEnabled}}):_c('PossibilitiesMobile',{attrs:{"animation-enabled":_vm.animationEnabled}})}
var staticRenderFns = []

export { render, staticRenderFns }